import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import { ReceiptService } from "../../../api/receipt.service";

export const useCancelReceipt = (setAlert?: (alert: any) => void, options?: any) => {
  const { id: txId } = useParams<{ id: string }>();
  const receiptService = new ReceiptService();

  return useMutation(
    async () => {
      if (!txId) throw new Error("Missing txId");
      try {
        await receiptService.cancelReceipt(txId);
      } catch (error: any) {
        if (setAlert) {
          setAlert({
            severity: "error",
            show: true,
            title: "Error",
            message:
              error?.response?.data?.description ||
              error?.description ||
              error?.message ||
              "Failed to cancel receipt.",
          });
        }
        throw error;
      }
    },
    options
  );
};